wbApp.controller('ContractsSendContractsParamsCtrl', ['$scope', '$modal', 'contractSvc',
function ($scope, $modal, contractSvc) {

    let editContractModel = contractSvc.transformModelForEdit($scope.contract);
    
    $scope.model = {
        contractTemplateType0Enabled: !!editContractModel.contractTemplateType0,
        contractTemplateType1Enabled: !!editContractModel.contractTemplateType1,
        contractTemplateType2Enabled: !!editContractModel.contractTemplateType2,
        contractTemplateType3Enabled: !!editContractModel.contractTemplateType3,
        contractTemplateType4Enabled: !!editContractModel.contractTemplateType4,
        contractTemplateType6Enabled: !!editContractModel.contractTemplateType6,
        contractTemplateType7Enabled: !!editContractModel.contractTemplateType7,

        contractTemplateType0: false,
        contractTemplateType1: false,
        contractTemplateType2: false,
        contractTemplateType3: false,
        contractTemplateType4: false,
        contractTemplateType6: false,
        contractTemplateType7: false,
    }

    $scope.isFormValid = function() {
        return !!$scope.model.contractTemplateType0 ||
            !!$scope.model.contractTemplateType1 ||
            !!$scope.model.contractTemplateType2 ||
            !!$scope.model.contractTemplateType3 ||
            !!$scope.model.contractTemplateType4 ||
            !!$scope.model.contractTemplateType6 ||
            !!$scope.model.contractTemplateType7;
    }

    $scope.onDetailSave = function (model) {
        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;
        
        let typesToSend = [];
        if (!!$scope.model.contractTemplateType0) {
            typesToSend.push(0);
        }
        if (!!$scope.model.contractTemplateType1) {
            typesToSend.push(1);
        }
        if (!!$scope.model.contractTemplateType2) {
            typesToSend.push(2);
        }
        if (!!$scope.model.contractTemplateType3) {
            typesToSend.push(3);
        }
        if (!!$scope.model.contractTemplateType4) {
            typesToSend.push(4);
        }
        if (!!$scope.model.contractTemplateType6) {
            typesToSend.push(6);
        }
        if (!!$scope.model.contractTemplateType7) {
            typesToSend.push(7);
        }

        contractSvc.sendContracts($scope.contract.id, typesToSend).$promise.then(function() {
            $scope.isSaving = false;
            $scope.$hide();
        }, function(error) {
            $scope.detailError = error;
            $scope.isSaving = false;
        })
        
    }
}]);
